export const BORDER_RADIUS = {
  default: '30px',
  formElement: '20px',
  menu: '10px',
}